// src/components/common/StatusDot.jsx
//
// Small colored indicator dot. Used for live status and health status.
// Pulse animation uses the shared `liveBlip` keyframes from index.css.

export default function StatusDot({ color, pulse = false, size = 7 }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: color,
        display: 'inline-block',
        animation: pulse ? 'liveBlip 2s ease-in-out infinite' : 'none',
      }}
    />
  );
}